var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('new-case-form',{attrs:{"internal":""},on:{"created":_vm.handleCaseCreated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }